export const formattedRedirectAfterLogin = (url, host, hash) => {
  if (hash.endsWith('/')) hash = hash.slice(0, -1)
  return `${url}?redirect_url=${host}#${hash}/`
}

export const formattedRedirectLogout = (url, host, hash) => {
  if (hash.endsWith('/')) hash = hash.slice(0, -1)
  return `${url}logout/?redirect_url=${host}#${hash}/`
}
